import React from 'react';
import Skeleton from 'react-loading-skeleton';
import SearchBoxLoading from './SearchBoxLoading';

type Props = {};

export default function HotelDetailLoadingPage({}: Props) {
  return (
    <div>
      <SearchBoxLoading />
      <section className="py-10 d-flex items-center bg-light-2">
        <div className="container">
          <div className="row y-gap-10 items-center justify-between">
            <div className="col-auto">
              <div className="row x-gap-10 y-gap-5 items-center text-14 text-light-1">
                <div className="col-auto">
                  <Skeleton width={400} height={30} />
                </div>
              </div>
              {/* End .row */}
            </div>
            {/* End .col-auto */}

            <div className="col-auto">
              <Skeleton width={100} height={30} />
            </div>
            {/* End col-auto */}
          </div>
          {/* End .row */}
        </div>
        {/* End .container */}
      </section>
      <section className="py-10 d-flex items-center">
        <div className="container">
          <div className="row y-gap-10 items-center justify-between">
            <div className="col-12">
              <div className="row x-gap-10 y-gap-5 items-center text-14 text-light-1">
                <div className="col-12">
                  <Skeleton width="100%" height={30} />
                </div>
              </div>
              {/* End .row */}
            </div>
            {/* End .col-auto */}

            {/* End col-auto */}
          </div>
          {/* End .row */}
        </div>
        {/* End .container */}
      </section>
      <section className="py-10 d-flex items-center ">
        <div className="container">
          <div className="row y-gap-10 items-center justify-between">
            <div className="col-auto">
              <div className="row x-gap-10 y-gap-5 items-center text-14 text-light-1">
                <div className="col-auto">
                  <Skeleton width={400} height={30} />
                </div>
              </div>
              {/* End .row */}
            </div>
            {/* End .col-auto */}

            <div className="col-auto">
              <Skeleton width={160} height={50} />
            </div>
            {/* End col-auto */}
          </div>
          {/* End .row */}
        </div>
        {/* End .container */}
      </section>

      <div className="container">
        <div className="row x-gap-20 y-gap-20">
          <div className="col-8">
            <div className="galleryGrid -type-1 ">
              <div className="galleryGrid__item ">
                <Skeleton width="100%" height={300} />
              </div>
              <div className="galleryGrid__item">
                <Skeleton width="100%" height={140} />
              </div>
              <div className="galleryGrid__item  ">
                <Skeleton width="100%" height={140} />
              </div>
              <div className="galleryGrid__item">
                <Skeleton width="100%" height={140} />
              </div>
              <div className="galleryGrid__item ">
                <Skeleton width="100%" height={140} />
              </div>
            </div>
            <div className="row y-gap-20 justify-between items-end pt-30">
              <div className="col-12">
                <div className="row x-gap-20  items-center">
                  <div className="col-12">
                    <Skeleton count={1} width="70%" height={50} />
                    <Skeleton className="mt-5" width="100%" height={30}></Skeleton>
                    <Skeleton className="mr-5" width="100%" height={150}></Skeleton>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-4">
            <div className="px-30 py-30 border-light rounded-4">
              <div className="mb-15">
                <Skeleton
                  style={{
                    height: '180px',
                  }}
                ></Skeleton>
                <div className="row y-gap-10">
                  <div className="col-12">
                    <div className="d-flex items-center">
                      <div className="col-12">
                        <div className="d-flex items-center">
                          <Skeleton width={30} height={30} />
                          <Skeleton width={200} height={30} className="ml-20"></Skeleton>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="d-flex items-center">
                      <div className="col-12">
                        <div className="d-flex items-center">
                          <Skeleton width={30} height={30} />
                          <Skeleton width={150} height={30} className="ml-20"></Skeleton>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="d-flex items-center">
                      <div className="col-12">
                        <div className="d-flex items-center">
                          <Skeleton width={30} height={30} />
                          <Skeleton width={250} height={30} className="ml-20"></Skeleton>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="border-top-light mt-15 mb-15" />
              <Skeleton width={150} height={40} />
              <div className="d-flex justify-between pt-10 ">
                <Skeleton width={50} height={30} />
                <Skeleton width={150} height={30} />
              </div>
              <div className="d-flex justify-between pt-10 ">
                <Skeleton width={30} height={30} />
                <Skeleton width={100} height={30} />
              </div>
              <div className="d-flex justify-between pt-10 ">
                <Skeleton width={40} height={30} />
                <Skeleton width={120} height={30} />
              </div>

              <div className="d-flex justify-between pt-10 ">
                <Skeleton width={60} height={30} />
                <Skeleton width={150} height={30} />
              </div>
              <div className="d-flex justify-between pt-10 ">
                <Skeleton width={50} height={30} />
                <Skeleton width={110} height={30} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
